// SPDX-License-Identifier: AGPL-3.0-or-later
//
// parley: soundboard constants (strand AG, docs/strands/soundboard.md).
// Fluxer has no soundboard, so this file is parley's own; it lives in
// @fluxer/constants because the limit defaults in @fluxer/limits need it.
// The numbers mirror internal/limits/defaults.go and internal/api/
// soundboard.go - the wire format only carries what differs from the
// defaults, so a mismatch would silently show the wrong number in the UI.

export const MAX_GUILD_SOUNDBOARD_SOUNDS = 48;
export const SOUNDBOARD_SOUND_MAX_SIZE = 512 * 1024;
export const SOUNDBOARD_SOUND_MAX_DURATION_MS = 5200;
export const SOUNDBOARD_SOUND_MIN_DURATION_MS = 100;
export const SOUNDBOARD_SOUND_NAME_MIN_LENGTH = 2;
export const SOUNDBOARD_SOUND_NAME_MAX_LENGTH = 32;

/** What the API's audio sniffing accepts (internal/media/audio.go). */
export const SOUNDBOARD_SOUND_MIME_TYPES: ReadonlyArray<string> = [
	'audio/mpeg',
	'audio/mp3',
	'audio/ogg',
	'audio/mp4',
	'audio/x-m4a',
	'audio/wav',
	'audio/x-wav',
];

export const SOUNDBOARD_SOUND_FILE_PICKER_ACCEPT = [
	...SOUNDBOARD_SOUND_MIME_TYPES,
	'.mp3',
	'.ogg',
	'.m4a',
	'.wav',
].join(',');
